import React from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {PureButton} from "components/Button";
import {useDispatch, useSelector} from "react-redux";
import {openTutorial, toggleMenu} from "modules/actions";
import {useMatch, useNavigate} from "react-router-dom";
import {isMenuOpen} from "modules/selectors";

const TutorialButton = styled(PureButton)`
	position: relative;
	color: #fff;
	font-size: 16px;
	font-weight: 500;

	&:after {
		content: "";
		transition: width ease-in-out 250ms;
		position: absolute;
		width: 0;
		left: 50%;
		transform: translateX(-50%);
		bottom: 14px;
		height: 3px;
		background: #fff;
	}

	&:hover {
		&:after {
			width: 100%;
		}
	}

	@media (max-width: 768px) {
		display: block;
		font-size: 14px;
		padding: 14px 0;
		line-height: 160%;
		width: 100%;
		text-align: left;

		&:after {
			display: none;
		}

		&:hover {
			color: ${({theme}) => theme.global.header_hover_color};
		}
	}
`;

export const TutorialLink: React.FC = () => {
	const dispatch = useDispatch();
	const {t} = useTranslation();
	const navigate = useNavigate();
	const isOpen = useSelector(isMenuOpen);
	const isHome = useMatch("/");

	const startTutorial = () => {
		if (isOpen) {
			dispatch(toggleMenu(false));
		}

		if (!isHome) {
			navigate("/", {
				state: {
					tutorial: true,
				},
			});
			return;
		}

		dispatch(openTutorial());
	};

	return <TutorialButton onClick={startTutorial}>{t("subheader.fifa.tutorial")}</TutorialButton>;
};
